export const globalVariable = {
    menuDirection: "top", //菜单方向 right和top
    title:'LncPheDB'
}